import { generateClient } from 'aws-amplify/api';

const client = generateClient();

// The file travels base64-encoded through AppSync to Lambda (6 MB invocation payload limit)
export const MAX_PUBLIC_DOCUMENT_SIZE_MB = 4;

/**
 * Checks a document before upload. Returns a translated error message, or null if the file is fine.
 */
export function validatePublicDocument(file, t) {
  if (file.type !== 'application/pdf') {
    return t("Only PDF files are allowed");
  }
  if (file.size > MAX_PUBLIC_DOCUMENT_SIZE_MB * 1024 * 1024) {
    return t("The file must not be larger than {{size}} MB", { size: MAX_PUBLIC_DOCUMENT_SIZE_MB });
  }
  return null;
}

const readAsBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result.replace(/^data:.+;base64,/, ''));
  reader.onerror = () => reject(reader.error);
  reader.readAsDataURL(file);
});

/**
 * Uploads a PDF that companies publish together with their content into the public bucket.
 * fileType selects the target folder in uploadLectureFiles ("productFile" -> ProductPDF/, "newsFile" -> newsPDF/).
 * Resolves to the File object to store on the record; rejects on any failure.
 */
export async function uploadPublicDocument(file, { companyId, fileType }) {
  const base64FileBuffer = await readAsBase64(file);
  const response = await client.graphql({
    query: /* GraphQL */ `
      mutation UploadLectureFile($base64FileBuffer: String!, $companyId: String!, $originalFileName: String, $fileType: String) {
        uploadLectureFile(base64FileBuffer: $base64FileBuffer, companyId: $companyId, originalFileName: $originalFileName, fileType: $fileType) {
          message
          fileName
          url
        }
      }
    `,
    variables: {
      base64FileBuffer,
      companyId,
      originalFileName: file.name,
      fileType,
    },
  });
  const result = response.data.uploadLectureFile;
  if (!result?.url) {
    throw new Error("uploadLectureFile returned no url");
  }
  return { fileName: result.fileName, url: result.url, name: file.name, type: fileType };
}
